import EventActionProto from '../event-action-proto';
import ExpenseCategoriesCollection from "../../model2/expenses/expense-category/collection";

export default class SessionExpenseCategoryReset extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);

        this.method     = sessionEvent.method;
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        switch (this.method) {
            case 'reset':
                // gd.session._expenseCategories = this.data //new CrmContactCollectionSession(this.data);
                // gd.session._expenseCategories = new ExpenseCategoriesCollection(this.data)

                if (!gd.session._expenseCategories) {
                    gd.session._expenseCategories = ExpenseCategoriesCollection.initFromJsonData(this.data)
                } else {
                    gd.session._expenseCategories.resetAndKeepOldModels(ExpenseCategoriesCollection.initFromJsonData(this.data).models)
                }

                break;
            default:
                console.error("#jjdfk-023 Incorrect session method")
                break;
        }
    }


}
